import $ from 'jquery';
import { validatePassword, PASSWORD_REQUIREMENTS } from 'common/utils/passwordValidation';

$(function () {
  const $password = $('#employee_password');
  const $passwordConfirmation = $('#employee_password_confirmation');
  const $submitButton = $('#submit-password-change');

  // Password toggle functionality
  $('.password-toggle').on('click', function () {
    const $toggle = $(this);
    const $input = $($toggle.data('target'));
    const $icon = $toggle.find('i');

    if ($input.attr('type') === 'password') {
      $input.attr('type', 'text');
      $icon.removeClass('fa-eye').addClass('fa-eye-slash');
    } else {
      $input.attr('type', 'password');
      $icon.removeClass('fa-eye-slash').addClass('fa-eye');
    }
  });

  if ($password.length === 0 || $passwordConfirmation.length === 0) return;

  // Disable the button initially when JavaScript loads
  $submitButton.prop('disabled', true);

  function validatePasswordFields() {
    const password = $password.val();
    const passwordConfirmation = $passwordConfirmation.val();

    const result = validatePassword(password, passwordConfirmation);

    PASSWORD_REQUIREMENTS.forEach(requirement => {
      const selector = `#requirement-${requirement.id}`;
      let isValid;

      if (requirement.needsConfirmation) {
        if (password.length > 0 && passwordConfirmation.length > 0) {
          isValid = requirement.validator(password, passwordConfirmation);
          validateRequirement(selector, isValid);
        } else {
          resetRequirement(selector);
        }
      } else {
        isValid = requirement.validator(password);
        validateRequirement(selector, isValid);
      }
    });

    $submitButton.prop('disabled', !result.isValid);
  }

  function validateRequirement(selector, isValid) {
    const $element = $(selector);
    const $icon = $element.find('.requirement-icon');
    const $text = $element.find('.requirement-text');

    if (isValid) {
      $icon
        .removeClass('fa-circle fas fa-times-circle far')
        .addClass('far fa-check-circle')
        .css({ color: 'green', 'font-size': '12px' });
      $text.css('color', 'black');
    } else {
      $icon
        .removeClass('fa-circle fas far fa-check-circle')
        .addClass('far fa-times-circle')
        .css({ color: 'red', 'font-size': '12px' });
      $text.css('color', 'black');
    }
  }

  function resetRequirement(selector) {
    const $element = $(selector);
    const $icon = $element.find('.requirement-icon');
    const $text = $element.find('.requirement-text');

    $icon
      .removeClass('far fa-check-circle fa-times-circle')
      .addClass('fas fa-circle')
      .css({ color: '#999', 'font-size': '12px' });
    $text.css('color', '');
  }

  $password.on('input keyup', validatePasswordFields);
  $passwordConfirmation.on('input keyup', validatePasswordFields);
});
